module.exports = __webpack_public_path__ + "lp/img/zoom_in_dark.f72c554b.svg";